import Roles from "../pages/Roles";
import Users from "../pages/Users";
import Groups from "../pages/Groups";
import MenuIcon from "./MenuIcon";
import AuditFrontend from "../pages/AuditFrontend";
import AuditBackend from "../pages/AuditBackend";
import Support from "../pages/Support";
import Home from "@pages/Home";
import Worksites from "@pages/Worksites";
import Tintometers from "@pages/Tintometers";
import PriceList from "@pages/PriceList";
import Faqs from "@pages/Assistant/Assistant";
import Connections from "@pages/Connections";
import SuggestedUsers from "@pages/SuggestedUsers";
import {Analytics} from "@pages/Analytics";
import Explorer from "@pages/Explorer";
import References from "@pages/References";
import Quotations from "@pages/Quotations";
import {MenuEntry} from "./types";


const menu: MenuEntry[] = [
  {
    name: "home",
    href: "/home",
    Icon: () => <MenuIcon name="Home" />,
    component: Home,
  },
  {
    name: "worksites",
    href: "/worksites",
    Icon: () => <MenuIcon name="Helmet" />,
    component: Worksites,
    home: "*", // Visible as home link in all countries for all roles
    description: "worksite_description",
  },
  {
    name: "tintometers",
    href: "/tintometers",
    Icon: () => <MenuIcon name="Paint" />,
    component: Tintometers,
    description: "tintometers_description",
    home: { it: ["resale_tintometer"] }, // Only visible as home link in Italy for `resale_tintometer` users
    roles: { it: ["admin", "resale_tintometer", "area_manager"] }, // Only accessible in Italy for the specified roles
  },
  {
    name: "pricelist",
    href: "/pricelist",
    Icon: () => <MenuIcon name="Frame" />,
    component: PriceList,
    description: "price_list_description",
    home: { it: "*" }, // Only visible as home link in Italy for `resale_tintometer` users
    roles: { it: "*" }, // Only accessible in Italy for the specified roles
  },
  {
    name: "documents",
    Icon: () => <MenuIcon name="Archive" />,
    dropdown: [
      {
        name: "references",
        href: "/references",
        component: References,
        roles: { it: ["admin", "field", "CS", "sales", "agent"] }, // Only accessible in Italy for the specified roles
      },
      {
        name: "quotations",
        href: "/quotations",
        component: Quotations,
        scopes: ["quotation:read"], // Visible in all countries for users with the specified scope
      },
      {
        name: "technical_documents",
        externalHref: "technical_documents",
        component: () => null, // No internal component, only external link
        home: "*", // Visible as home link in all countries for all roles
        description: "technical_description",
      },
      {
        name: "structural_download",
        externalHref: "structural_download",
        component: () => null, // No internal component, only external link
        home: ["resale_tintometer"], // Visible as home link in Italy and Spain for `resale_tintometer` users
        homeNegate: true,
        description: "structural_description",
      },
    ],
  },
  {
    name: "customer_service",
    Icon: () => <MenuIcon name="Customer-Service" />,
    dropdown: [
      {
        name: "kerakoll_assistant",
        component: (props: any) => <Faqs {...props} />,
        home: { it: "*" }, // Visible as home link in Italy for all roles
        roles: { it: "*" }, // Only accessible in Italy for all roles
        description: "kerakoll_assistant_description",
        href: "/kerakoll_assistant",
      },
      {
        scopes: ["ticket:create"], // Visible in all countries for users with the specified scope
        name: "support",
        href: "/support",
        component: Support,
      },
    ],
  },
  {
    name: "e_commerce",
    externalHref: "e_commerce",
    Icon: () => <MenuIcon name="Cart" />,
    component: () => null,
    roles: { it: ["admin", "agent"], es: ["admin", "agent"] }, // Only accessible in Italy and Spain for the specified roles
    home: { it: ["admin", "agent"], es: ["admin", "agent"] }, // Visible as home link in Italy and Spain for the specified roles
    description: "e_commerce_description",
  },
  {
    name: "users",
    Icon: () => <MenuIcon name="Accounts" />,
    dropdown: [
      {
        href: "/connections",
        name: "connections",
        component: Connections,
        roles: ["admin", "CS", "sales", "field", "area_manager", "agent"], // Only accessible for the specified roles, in all countries
      },
      {
        href: "/suggested_users",
        name: "suggested_users",
        component: SuggestedUsers,
        scopes: ["suggested_users:read"], // Only accessible for users with the specified scope, in all countries
      },
      {
        scopes: ["user:read"], // Only accessible for users with the specified scope, in all countries
        href: "/users",
        name: "users_settings",
        component: Users,
      },
      {
        scopes: ["role:update"], // Only accessible for users with the specified scope, in all countries
        href: "/roles",
        name: "roles_settings",
        component: Roles,
      },
      {
        scopes: ["role:update"], // Only accessible for users with the specified scope, in all countries
        href: "/groups",
        name: "groups_settings",
        component: Groups,
      },
    ],
  },
  {
    name: "analytics",
    Icon: () => <MenuIcon name="Trend-Up-Bold" />,
    dropdown: [
      {
        name: "business_monitoring",
        href: "/analytics",
        component: Analytics,
        roles: {
          it: [
            "admin",
            "CS",
            "sales",
            "field",
            "agent",
            "sales_director",
            "area_manager",
          ],
          es: ["admin"],
        },
      },
      {
        scopes: ["audit:read"], // Only accessible for users with the specified scope, in all countries
        href: "/audit/frontend",
        name: "audit_frontend",
        component: AuditFrontend,
      },
      {
        scopes: ["audit:read"], // Only accessible for users with the specified scope, in all countries
        href: "/audit/backend",
        name: "audit_backend",
        component: AuditBackend,
      },
    ],
  },
  {
    name: "explorer",
    href: "/explorer/:tableName",
    Icon: () => <MenuIcon name="Settings" />,
    component: Explorer,
    roles: ["admin", "CS", "field"], // Only accessible for the specified roles, in all countries
    notExact: true,
    initialUrl: "/explorer/services",
  },
];

export default menu;
